<template>
  <div
    class="wrapper"
    :style="{ borderColor: `rgba(96,71,18,0.4)` }"
    @contextmenu.prevent="blockRightButton"
  >
    <comp-header
      hide-feedback
      show-haohuo
      @close="closeReport"
      @feedback="feedbackReport"
    />
    <VideoUserInfo
      @showPay="showPayFn"
      @showChangeUserInfoPop="showChangeUserInfoPop"
      @toRank="report({ click: 53 })"
    />
    <div
      class="wrap_scroll"
      :style="{ height: '620px' }"
    >
      <slot />
    </div>

    <!-- 修改用户信息弹窗 -->
    <ChangeUserInfoPop
      v-if="isChangeUserInfoPop"
      v-model="isChangeUserInfoPop"
    />
  </div>
</template>
<script>
import VideoUserInfo from '@/components/userInfo/VideoUserInfo.vue'
import CompHeader from '@/layout/Header.vue'
import ChangeUserInfoPop from '@/components/userInfo/ChangeUserInfoPop'

import { defineComponent, onMounted, nextTick, onBeforeMount, ref, provide } from '@vue/composition-api'
import { useReflectiveInjector } from '@zhfe/vue2-di-plugin'

import client from '@/client/'
import { STAY_PAGE_NUM } from '@/config/dataMap'
import { VideoHeaderService } from './video-header.service.ts'
import { UserService } from '@/services/user.service'

export default defineComponent({
  name: 'VideoHeader',
  components: {
    VideoUserInfo,
    CompHeader,
    ChangeUserInfoPop,
  },

  setup (_, context) {
    const injector = useReflectiveInjector([VideoHeaderService])
    const video = injector.get(VideoHeaderService)
    const user = injector.get(UserService)
    const isChangeUserInfoPop = ref(false)

    function closeReport () {
      client.home.REPORT.reportCenterStayTimeKfmt({ show_page: STAY_PAGE_NUM[context.root.$route.name], user_login: user.loginStatus ? 1 : 2 })
      report({ click: 7, user_login: user.loginStatus ? 1 : 2 })
      video.clearScrollPosition() // 清除滚动条位置
    }

    function feedbackReport () {
      const id = video.getFeedbackReportId
      report({ click: id, user_login: user.loginStatus ? 1 : 2 })
    }

    function showChangeUserInfoPop () {
      isChangeUserInfoPop.value = true
    }

    function showPayFn () {
      const _parent = document.querySelector('.wrap_scroll')
      _parent.scrollTop = 0
    }

    function report ({
      click = 0,
      hover = 0,
      sub_mode = context.refs?.payModule?.sub_mode || 0, user_login = 0
    }) {
      video.report({ main_click: click, main_hover: hover, sub_mode, user_login })
    }

    return {
      showChangeUserInfoPop,
      showPayFn,
      report,
      // 屏蔽右键
      blockRightButton () {
        return false
      },
      isChangeUserInfoPop,
      feedbackReport,
      closeReport
    }
  },
})
</script>
<style lang="scss">
::selection {
  background: transparent;
}
.wrapper {
  position: relative;
  width: 702px;
  height: 742px;
  margin: 0 auto;
  border: 1px solid rgba(21, 161, 225, 0.4);
  box-sizing: border-box;
}

.noScroll {
  overflow-y: hidden;
}
.wrap_scroll {
  position: relative;
  background: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
}
</style>
